import { render } from "./CreateChatwootAccount.vue?vue&type=template&id=c5db053c"
import script from "./CreateChatwootAccount.vue?vue&type=script&lang=js"
export * from "./CreateChatwootAccount.vue?vue&type=script&lang=js"

import "./CreateChatwootAccount.vue?vue&type=style&index=0&id=c5db053c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__